import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighlightPipe } from './commons/pipes/highlight.pipe';
import { PortalModule } from '@angular/cdk/portal';
import { SafeUrlPipe } from './commons/pipes/safe-url.pipe';
import { API_INTERCONEXION, API_INTERCONEXION_VISORBYTOKEN, ENV_TOKEN, INTERCONEXION_GATEWAY, INTERCONEXION_ICOIJ, INTERCONEXION_METHOD_DELETEDOCAUTOENROLAMIENTO, INTERCONEXION_METHOD_DEMANDASBYFILTER, INTERCONEXION_METHOD_GETACUSEDEMANDA, INTERCONEXION_METHOD_GETACUSEDEMBYFOLIO, INTERCONEXION_METHOD_GETACUSEPROMOCION, INTERCONEXION_METHOD_GETDEPENDENCIAORG, INTERCONEXION_METHOD_GETPALABRAS, INTERCONEXION_METHOD_PROMOTIONSBYFILTER, INTERCONEXION_METHOD_REGISTRARAUTOENROLAMIENTO, INTERCONEXION_METHOD_UPDATETRANSACTIONDOC, INTERCONEXION_METHOD_VALIDARCORREOAUTOENROLAMIENTO, INTERCONEXION_PROMOTIONS, INTERCONEXION_RECUPERARPASS, INTERCONEXION_REESTABLECERPASS } from './app-module.token';
import { NgSelectModule } from '@ng-select/ng-select';
import { LibInterconexionEEModule } from 'interconexion.ee-lib';
import { environment } from '../environments/environment';
import { CJFSISEWebCaptchaLibModule } from 'cjf.sise.web.captcha-lib';


@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    PortalModule,
    HighlightPipe,
    SafeUrlPipe,
    NgSelectModule,
    LibInterconexionEEModule.forRoot(environment),
    CJFSISEWebCaptchaLibModule.forRoot(environment),
  ],
  exports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    PortalModule,
    HighlightPipe,
    SafeUrlPipe,
    NgSelectModule
  ],
  providers: [
    { provide: API_INTERCONEXION, useValue: 'wsInterconexionEEApi/ExpedienteElectronicoServiceAPI/' },
    { provide: API_INTERCONEXION_VISORBYTOKEN, useValue: 'VisorByToken/' },
    { provide: INTERCONEXION_GATEWAY, useValue: 'oaj.icoij.gateway/' },
    { provide: INTERCONEXION_ICOIJ, useValue: 'icoij/' },
    { provide: INTERCONEXION_PROMOTIONS, useValue: 'Promotions/' },
    { provide: INTERCONEXION_RECUPERARPASS, useValue: 'recuperarPassword' },
    { provide: INTERCONEXION_REESTABLECERPASS, useValue: 'reestablecerPassword' },
    { provide: INTERCONEXION_METHOD_PROMOTIONSBYFILTER, useValue: 'GetPromotionByFilter' },
    { provide: INTERCONEXION_METHOD_DEMANDASBYFILTER, useValue: 'GetDemandaByFilter' },
    { provide: INTERCONEXION_METHOD_GETACUSEDEMANDA, useValue: 'getAcuseDemandElect' },
    { provide: INTERCONEXION_METHOD_GETACUSEPROMOCION, useValue: 'getAcusePromotionElect' },
    { provide: INTERCONEXION_METHOD_GETDEPENDENCIAORG, useValue: 'getDependenciaOrg' },
    { provide: INTERCONEXION_METHOD_REGISTRARAUTOENROLAMIENTO, useValue: 'RegistrarAutoEnrolamiento' },
    { provide: INTERCONEXION_METHOD_VALIDARCORREOAUTOENROLAMIENTO, useValue: 'ValidarCorreo' },
    { provide: INTERCONEXION_METHOD_DELETEDOCAUTOENROLAMIENTO, useValue: 'DeleteDocumento' },
    { provide: INTERCONEXION_METHOD_GETPALABRAS, useValue: 'AutoEnrolamiento/GetValidarPalabras' },
    { provide: INTERCONEXION_METHOD_UPDATETRANSACTIONDOC, useValue: 'ActualizaTransaccionDocumento' },
    { provide: INTERCONEXION_METHOD_GETACUSEDEMBYFOLIO, useValue: 'getAcuseDemandElectByFolio' },
    { provide: ENV_TOKEN, useValue: environment },
  ]
})
export class AppModule { }
